export const tablePaginationStyles = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    px: 2,
    py: 2,
    borderTop: '1px solid',
    borderColor: 'divider',
    bgcolor: 'background.paper',
  },

  rowsInfo: {
    fontSize: '0.875rem',
    color: 'text.secondary',
    fontWeight: 500,
  },

  pagination: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },

  // Styles now handled by MyButton customVariant
  pageButton: {},
  pageButtonActive: {},

  navButton: {
    minWidth: '32px',
    height: '32px',
    borderRadius: '6px',
  },
};
